module.exports = __webpack_public_path__ + "static/media/Trust-Build.34c023fb.jpg";